
export class OpeningCutscene {
    private static readonly videoPath =
        `${import.meta.env.BASE_URL}assets/video/penangkap-hantu-intro.mp4`;

    async play(): Promise<void> {
        return new Promise<void>((resolve) => {
            const overlay = document.createElement("div");
            overlay.className = "opening-cutscene";

            const video = document.createElement("video");
            video.className = "opening-cutscene-video";

            video.src = OpeningCutscene.videoPath;
            video.playsInline = true;
            video.setAttribute("playsinline", "");
            video.setAttribute("webkit-playsinline", "");
            video.preload = "auto";
            video.controls = false;
            video.loop = false;

            const skipButton = document.createElement("button");
            skipButton.type = "button";
            skipButton.className = "cutscene-skip";
            skipButton.textContent = "Langkau";

            const playButton = document.createElement("button");
            playButton.type = "button";
            playButton.className = "cutscene-play";
            playButton.textContent = "Mainkan Video";
            playButton.hidden = true;

            overlay.append(video, skipButton, playButton);
            document.body.appendChild(overlay);

            let finished = false;
            let loadTimeout: number | undefined;

            const finish = () => {
                if (finished) return;
                finished = true;

                window.clearTimeout(loadTimeout);

                video.pause();

                video.removeEventListener("ended", finish);
                video.removeEventListener("error", handleError);
                video.removeEventListener("playing", handlePlaying);

                skipButton.removeEventListener("click", finish);
                playButton.removeEventListener("click", startPlayback);
                document.removeEventListener("keydown", onKeyDown);

                video.removeAttribute("src");
                video.load();

                overlay.remove();

                resolve();
            };

            const handleError = () => {
                console.warn("Opening video unavailable. Starting game.");
                finish();
            };

            const handlePlaying = () => {
                window.clearTimeout(loadTimeout);
                playButton.hidden = true;
            };

            const onKeyDown = (event: KeyboardEvent) => {
                if (event.key === "Escape") {
                    event.preventDefault();
                    finish();
                }
            };

            const startPlayback = async () => {
                if (finished) return;

                try {
                    await video.play();

                    if (!finished) {
                        playButton.hidden = true;
                    }
                } catch (error) {
                    if (finished) return;

                    console.warn("Video playback requires interaction:", error);
                    playButton.hidden = false;

                    // User can tap Play or Langkau.
                    window.clearTimeout(loadTimeout);
                }
            };

            video.addEventListener("ended", finish);
            video.addEventListener("error", handleError);
            video.addEventListener("playing", handlePlaying);

            skipButton.addEventListener("click", finish);
            playButton.addEventListener("click", startPlayback);
            document.addEventListener("keydown", onKeyDown);

            // Avoid an infinite black screen if the video cannot load.
            loadTimeout = window.setTimeout(() => {
                if (!finished && video.readyState === HTMLMediaElement.HAVE_NOTHING) {
                    console.warn("Opening video loading timeout.");
                    finish();
                }
            }, 12000);

            void startPlayback();
        });
    }
}
